import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Counter-based: increment on setLoader(true), decrement on setLoader(false).
  // Clamped at 0 so double-decrements from try+finally patterns are harmless.
  // isLoading is derived: count > 0
  loadingCount: 0,
  isLoading: false,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoader: (state, action) => {
      if (action.payload) {
        state.loadingCount += 1;
      } else {
        state.loadingCount = Math.max(0, state.loadingCount - 1);
      }
      state.isLoading = state.loadingCount > 0;
    },
  },
});

export const { setLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
